import { observer } from "mobx-react";
import useStore from "../../../../hooks/useStore";
import AddForm from "./addForm";
import { findKpi, generateYearArray } from "../../../../utils/helpers";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ApprovalEnums,
  MONTHS_ARRAY_FULLNAME,
  SOCIAL_GROUP_CONSTANTS,
  USER_ROLE,
} from "../../../../constants/constants";
import ShowForm from "./showForm";
import { useAuth } from "../../../../context/authProvider";
import { Modal, Button } from "react-bootstrap";
import LogTableBody from "../../logForms/socialLog";
import * as XLSX from "xlsx";
//import * as XLSX from "xlsx-style";


const SocialPage = ({ groupConstant, routeSubPath }) => {
  const navigate = useNavigate();
  const { year: tempYear } = useLocation().state || {};
  const [year, setYear] = useState(tempYear || 0);
  const [month, setMonth] = useState("");

  const {
    social: { fetch, formData },
    formStore: { approveForm, deleteForm, logRaw, logData },
    companyStore: { kpiName, companyUnit, assignUnitsRaw, fetchAssignUnits, getCompanyUnitName },
    userStore: { employeeKpis, user },
  } = useStore();
  const { showAlert } = useAuth();
  // State for modals
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(""); // "approve" or "delete"

  //calculations
  const count = useMemo(
    () =>
      new Set(
        Object.keys(SOCIAL_GROUP_CONSTANTS[groupConstant]).map((ele) => ele[0])
      ).size,
    [groupConstant]
  );

  // useEffect(() => {
  //   if (routeSubPath === "monthly_parameter") {
  //     if (!tempYear && year && month) {
  //       fetch({ year, month });
  //     }
  //   } else {
  //     if (!tempYear && year) {
  //       fetch({ year });
  //     }
  //   }
  // }, [fetch, tempYear, year, routeSubPath, month]);

  useEffect(() => {
    if (!companyUnit || !year || (routeSubPath === "monthly_parameter" && !month)) return;
  
    const params = { year, companyUnit };
    if (routeSubPath === "monthly_parameter") {
      params.month = month;
    }
  
    fetch(params);
  }, [fetch, tempYear, year, month, routeSubPath, companyUnit]);

  
  useEffect(() => {
    if (!assignUnitsRaw?.length) {
      fetchAssignUnits();
    }
  }, [assignUnitsRaw]);
  

  const showData = useMemo(
    () =>
      Array.from(new Set(formData?.map((ele) => ele?.fieldGroup[0]))).length ===
      count,
    [count, formData]
  );
  const approvalStatus = formData?.[0]?.approvalStatus;
  const formId = formData?.[0]?.formId;
  const yearData = formData?.[0]?.year;

  const kpi = useMemo(
    () => findKpi({ kpis: employeeKpis, value: kpiName, field: "name" }),
    [employeeKpis, kpiName]
  );

  const handleModalShow = (type) => {
    setModalType(type);
    setShowModal(true);
  };
  const handleModalLogShow = async (formId) => {
    // Fetch form log data
    await logData({ formId });
    setModalType("log");
    setShowModal(true);
  };
  const handleModalClose = () => {
    setShowModal(false);
    setModalType("");
  };

  // const exportSocialFormToExcel = (formData, groupConstant, approvalStatus,year) => {
  //   if (!formData || formData.length === 0) {
  //     alert("No data found to export.");
  //     return;
  //   }
  
  //   if (approvalStatus !== "approved") {
  //     alert("Form not approved. Cannot export.");
  //     return;
  //   }
  
  //   const groupOrder = Object.keys(SOCIAL_GROUP_CONSTANTS[groupConstant]);
  //   const sheetData = [["S.No", "KPI Name", "Value"]];
  
  //   let serialNo = 1;
  //   const addedMainHeadings = new Set();
  
  //   groupOrder.forEach((groupKey) => {
  //     const mainKey = groupKey.includes("_") ? groupKey.split("_")[0] : groupKey;
  
  //     // If it's a subgroup, ensure its parent heading is printed once
  //     if (!addedMainHeadings.has(mainKey)) {
  //       const hasGroupData = formData.some(
  //         (entry) =>
  //           entry.fieldGroup === mainKey ||
  //           entry.fieldGroup.startsWith(`${mainKey}_`)
  //       );
  
  //       if (hasGroupData && SOCIAL_GROUP_CONSTANTS[groupConstant][mainKey]) {
  //         sheetData.push(["", SOCIAL_GROUP_CONSTANTS[groupConstant][mainKey], ""]);
  //         addedMainHeadings.add(mainKey);
  //       }
  //     }
  
  //     // Get and sort matching entries
  //     const entries = formData
  //       .filter((entry) => entry.fieldGroup === groupKey)
  //       .sort((a, b) => Number(a.position) - Number(b.position));
  
  //     if (entries.length > 0) {
  //       // Add this subgroup label (if different from main group)
  //       if (groupKey !== mainKey) {
  //         sheetData.push([
  //           "",
  //           SOCIAL_GROUP_CONSTANTS[groupConstant][groupKey] || groupKey,
  //           "",
  //         ]);
  //       }
  
  //       // Add rows for each field under this groupKey
  //       entries.forEach((entry) => {
  //         sheetData.push([
  //           serialNo++,
  //           entry.fieldName,
  //           entry.value ?? "",
  //         ]);
  //       });
  
  //       sheetData.push(["", "", ""]); // gap between groups
  //     }
  //   });
  
  //   // Create and export
  //   const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Social Form");
  
  //   XLSX.writeFile(workbook, "social_form_data.xlsx");
  // };
      

  const exportSocialFormToExcel = (formData, groupConstant, approvalStatus, year) => {
    if (!formData || formData.length === 0) {
      alert("No data found to export.");
      return;
    }
  
    if (approvalStatus !== "approved") {
      alert("Form not approved. Cannot export.");
      return;
    }

    const unitName = getCompanyUnitName?.() ?? "Unknown Unit";
  
    const groupOrder = Object.keys(SOCIAL_GROUP_CONSTANTS[groupConstant]);
  //  const sheetData = [["S.No", "KPI Name",`Value (${year})`]];
  const sheetData = [
    ["Client Name", "Harman Finochem Limited"],
    ["Location", unitName], 
    [],
    ["Sr.No", "KPI Name", `Current Value (${year})`],
  ];
  
    let serialNo = 1;
    const addedMainHeadings = new Set();
  
    groupOrder.forEach((groupKey) => {
      const mainKey = groupKey.includes("_") ? groupKey.split("_")[0] : groupKey;
  
      // Add main KPI heading if not already added
      if (!addedMainHeadings.has(mainKey)) {
        const hasGroupData = formData.some(
          (entry) =>
            entry.fieldGroup === mainKey ||
            entry.fieldGroup.startsWith(`${mainKey}_`)
        );
  
        if (hasGroupData && SOCIAL_GROUP_CONSTANTS[groupConstant][mainKey]) {
          sheetData.push([
            serialNo++,
            SOCIAL_GROUP_CONSTANTS[groupConstant][mainKey],
            ""
          ]);
          addedMainHeadings.add(mainKey);
        }
      }
  
      // Always add subheading if label exists (even if no entries)
      if (
        groupKey !== mainKey &&
        SOCIAL_GROUP_CONSTANTS[groupConstant][groupKey]
      ) {
        sheetData.push([
          "",
          SOCIAL_GROUP_CONSTANTS[groupConstant][groupKey],
          ""
        ]);
      }
  
      // Add the actual field entries under this group
      const entries = formData
        .filter((entry) => entry.fieldGroup === groupKey)
        .sort((a, b) => Number(a.position) - Number(b.position));
  
      entries.forEach((entry) => {
        sheetData.push([
          "",
          `• ${entry.fieldName}`,
          entry.value ?? ""
        ]);
      });
  
      // Add empty line between sections
      if (entries.length > 0) {
        sheetData.push(["", "", ""]);
      }
    });
  
    // Create worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Social Form");
  
    XLSX.writeFile(workbook, `social_form_data_${year}.xlsx`);
  };
  

  const handleConfirmAction = () => {
    if (modalType === "approve") {
      approveForm({
        formId,
        type: "social",
        showAlert,
        status: ApprovalEnums.Approved,
        navigate,
        // goback: true,
        year,
        month
      });
    } else if (modalType === "delete") {
      deleteForm({
        formId,
        type: "social",
        showAlert,
        status: ApprovalEnums.Pending,
        navigate,
        // goback: true,
        year,
        month
      });
    }
    handleModalClose();
  };


  // useEffect(() => {
  //   if (!formData || formData.length === 0) return;
  
  //   const grouped = {};
  
  //   formData.forEach((item) => {
  //     const key = item.fieldGroup?.[0];
  //     if (!grouped[key]) grouped[key] = [];
  //     grouped[key].push(item);
  //   });
  
  //   console.log("🧾 Grouped formData by fieldGroup[0]:", grouped);
  //   console.log("📚 Order from SOCIAL_GROUP_CONSTANTS:", Object.keys(SOCIAL_GROUP_CONSTANTS[groupConstant]).sort());
  // }, [formData, groupConstant]);
  



  return (
    <div className="add-water-page">
      <div className="card p-4">
        <div className="mb-3">
         
          {/* {routeSubPath === "monthly_parameter" ? (
            <>
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">Year</label>
                  <select
                    value={year}
                    className="form-select"
                    onChange={(event) => setYear(event.target.value)}
                  >
                    <option key="default" value={0}>
                      Select Year
                    </option>
                    {generateYearArray().map((val) => (
                      <option key={`${val}-options`} value={val}>{`FY${val}`}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Month</label>
                  <select
                    value={month}
                    className="form-select"
                    onChange={(event) => setMonth(event.target.value)}
                  >
                    <option key="default" value="">
                      Select Month
                    </option>
                    {MONTHS_ARRAY_FULLNAME.filter((mon, index) => 
                      // If the selected year is the current year, show only months up to the current month
                      year == new Date().getFullYear() ? new Date().getMonth() >= index : true
                    ).map((val) => (
                      <option key={`${val}-options`} value={val}>
                        {val}
                      </option>
                    ))}
                  </select>
                  <Button
  variant="success"
  className="mb-3"
  onClick={() =>
    exportSocialFormToExcel(formData, groupConstant, approvalStatus, year)
  }
  disabled={!formData?.length || approvalStatus !== "approved"}
>
  Download Excel
</Button>

                  
                </div>
              </div>
            </>
          ): (
            <>
              <div className="row">
                <div className="col-md-12">
                  <label className="form-label">Year</label>
                  <select
                    value={year}
                    className="form-select"
                    onChange={(event) => setYear(event.target.value)}
                  >
                    <option key="default" value={0}>
                      Select Year
                    </option>
                    {generateYearArray().map((val) => (
                      <option key={`${val}-options`} value={val}>{`FY${val}`}</option>
                    ))}
                  </select>
                 
                  {/* <Button
  variant="success"
  className="mb-3"
  onClick={() => exportSocialFormToExcel(formData, groupConstant, approvalStatus,year)}
  disabled={!formData?.length || approvalStatus !== "approved"}
>
  Download Excel
</Button> 
<Button
  variant="success"
  className="mb-3"
  onClick={() =>
    exportSocialFormToExcel(formData, groupConstant, approvalStatus, year)
  }
  disabled={!formData?.length || approvalStatus !== "approved"}
>
  Download Excel
</Button>





                </div>
              </div>
            </>
          )} */}
{routeSubPath === "monthly_parameter" ? (
  <>
    <div className="row mb-3">
      <div className="col-md-6">
        <label className="form-label fw-semibold">Year</label>
        <select
          value={year}
          className="form-select"
          onChange={(event) => setYear(event.target.value)}
        >
          <option key="default" value={0}>Select Year</option>
          {generateYearArray().map((val) => (
            <option key={`${val}-option`} value={val}>{`FY${val}`}</option>
          ))}
        </select>
      </div>

      <div className="col-md-6">
        <label className="form-label fw-semibold">Month</label>
        <select
          value={month}
          className="form-select"
          onChange={(event) => setMonth(event.target.value)}
        >
          <option key="default" value="">Select Month</option>
          {MONTHS_ARRAY_FULLNAME.filter((mon, index) =>
            year == new Date().getFullYear() ? new Date().getMonth() >= index : true
          ).map((val) => (
            <option key={`${val}-option`} value={val}>{val}</option>
          ))}
        </select>
      </div>
    </div>

    <div className="row">
      <div className="col-md-12">
        <Button
          variant="success"
          onClick={() =>
            exportSocialFormToExcel(formData, groupConstant, approvalStatus, year)
          }
          disabled={!formData?.length || approvalStatus !== "approved"}
        >
          <i className="mdi mdi-download me-1"></i> Download Excel
        </Button>
      </div>
    </div>
  </>
) : (
  <>
    <div className="row mb-3">
      <div className="col-md-6">
        <label className="form-label fw-semibold">Year</label>
        <select
          value={year}
          className="form-select"
          onChange={(event) => setYear(event.target.value)}
        >
          <option key="default" value={0}>Select Year</option>
          {generateYearArray().map((val) => (
            <option key={`${val}-option`} value={val}>{`CY${val}`}</option>
          ))}
        </select>
      </div>
    </div>

    <div className="row">
      <div className="col-md-12">
        <Button
          variant="success"
          onClick={() =>
            exportSocialFormToExcel(formData, groupConstant, approvalStatus, year)
          }
          disabled={!formData?.length || approvalStatus !== "approved"}
        >
          <i className="mdi mdi-download me-1"></i> Download Excel
        </Button>
      </div>
    </div>
  </>
)}



           {formData?.[0]?.approvalStatus && Boolean(year) && month && routeSubPath === "monthly_parameter" && (
            <div className="table-responsive mt-3 approval-table">
              <table className="table align-middle table-bordered table-nowrap mb-0  ">
                <thead>
                  <th>Updated By</th>
                  <th className=" p-3">Month</th>
                  <th className=" p-3">Status</th>
                  <th className=" p-3">Approved By:</th>
                  <th>Log</th>
                  <th>Action</th>
                </thead>
                {/* {formData?.[0]?.approvalStatus &&( */}
                <tbody>
                  <tr>
                    <td>
                      <div>
                        <div>
                          {formData?.[0]?.updater?.first_name ?? "-"}{" "}
                          {formData?.[0]?.updater?.last_name ?? "-"}
                        </div>
                        {formData?.[0]?.updatedBy && (
                          <div style={{ fontSize: "0.8em", color: "gray" }}>
                            (
                            {formData?.[0]?.updatedBy
                              ? new Date(
                                  formData?.[0]?.updatedAt
                                ).toLocaleDateString("en-GB")
                              : "-"}
                            )
                          </div>
                        )}
                      </div>
                    </td>
                    <td>{formData?.[0]?.months || "-"}</td>
                    <td>
                      {formData?.[0]?.approvalStatus === "approved"
                        ? "Approved"
                        : "Pending"}{" "}
                    </td>
                    <td>
                      <div>
                        <div>
                          {formData?.[0]?.approver?.first_name ?? "-"}{" "}
                          {formData?.[0]?.approver?.last_name ?? "-"}
                        </div>
                        {formData?.[0]?.approvedAt && (
                          <div style={{ fontSize: "0.8em", color: "gray" }}>
                            (
                            {formData?.[0]?.approvedAt
                              ? new Date(
                                  formData?.[0]?.approvedAt
                                ).toLocaleDateString("en-GB")
                              : "-"}
                            )
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                      <i
                        type="button"
                        onClick={() => handleModalLogShow(formId)}
                        className="mdi mdi-dots-vertical"
                      ></i>
                    </td>
                    {/* {approvalStatus !== "approved" ? (
                      <td>
                        <div className="d-flex mt-2 gap-2 justify-content-center ">
                          {kpi.isEdited && !kpi.isApproved && (
                            <button
                              className="btn btn-primary"
                              type="button"
                              onClick={() => {
                                navigate("/company/approve/social", {
                                  state: {
                                    year,
                                    groupConstant,
                                    type: "social",
                                    month,
                                    // kpiName,
                                  },
                                });
                              }}
                            >
                              Edit
                            </button>
                          )}
                          {(kpi.isApproved ||
                            user.role === USER_ROLE.Company) && (
                            <>
                              <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => handleModalShow("approve")}
                              >
                                Approve
                              </button>
                              <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => {
                                  navigate("/company/approve/social", {
                                    state: {
                                      year,
                                      groupConstant,
                                      type: "social",
                                      // kpiName,
                                      month,
                                    },
                                  });
                                }}
                              >
                                Edit
                              </button>
                              <button
                                className="btn btn-danger"
                                type="button"
                                onClick={() => handleModalShow("delete")}
                              >
                                Delete
                              </button>
                            </>
                          )}
                        </div>
                      </td>
                    ) : (
                      <td>-</td>
                    )} */}
                    {approvalStatus === "approved" ? (
                      <td>
                        <div className="d-flex mt-2 gap-2 justify-content-center">
                          {(user.role === USER_ROLE.Company || user.department === "Admin") ? (
                            <button
                              className="btn btn-danger"
                              type="button"
                              onClick={() => handleModalShow("delete")}
                            >
                              Delete
                            </button>
                          ) : (
                            <span>-</span>
                          )}
                        </div>
                      </td>
                        ) : (
                        <td>
                          <div className="d-flex mt-2 gap-2 justify-content-center">
                            {(user.role === USER_ROLE.Company || user.department === "Admin" || kpi.isApproved) ? (
                              <>
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  onClick={() => handleModalShow("approve")}
                                >
                                  Approve
                                </button>
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  onClick={() => {
                                    navigate("/company/approve/social", {
                                      state: {
                                        year,
                                        groupConstant,
                                        type: "social",
                                        month,
                                      },
                                    });
                                  }}
                                >
                                  Edit
                                </button>
                                <button
                                  className="btn btn-danger"
                                  type="button"
                                  onClick={() => handleModalShow("delete")}
                                >
                                  Delete
                                </button>
                              </>
                            ) : (
                              kpi?.isEdited && (
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  onClick={() => {
                                    navigate("/company/approve/social", {
                                      state: {
                                        year,
                                        groupConstant,
                                        type: "social",
                                        month,
                                      },
                                    });
                                  }}
                                >
                                  Edit
                                </button>
                              )
                            )}
                          </div>
                        </td>
                      )}

                  </tr>
                </tbody>
                {/* )} */}
              </table>
            </div>
          )}
          {/* approval status Message  */}
          {formData?.[0]?.approvalStatus && Boolean(year) && routeSubPath !== "monthly_parameter"&& (
            <div className="table-responsive mt-3 approval-table">
              <table className="table align-middle table-bordered table-nowrap mb-0  ">
                <thead>
                  <th>Updated By</th>
                  <th className=" p-3">Status</th>
                  <th className=" p-3">Approved By:</th>
                  <th>Log</th>
                  <th>Action</th>
                </thead>
                {/* {formData?.[0]?.approvalStatus &&( */}
                <tbody>
                  <tr>
                    <td>
                      <div>
                        <div>
                          {formData?.[0]?.updater?.first_name ?? "-"}{" "}
                          {formData?.[0]?.updater?.last_name ?? "-"}
                        </div>
                        {formData?.[0]?.updatedBy && (
                          <div style={{ fontSize: "0.8em", color: "gray" }}>
                            (
                            {formData?.[0]?.updatedBy
                              ? new Date(
                                  formData?.[0]?.updatedAt
                                ).toLocaleDateString("en-GB")
                              : "-"}
                            )
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                      {formData?.[0]?.approvalStatus === "approved"
                        ? "Approved"
                        : "Pending"}{" "}
                    </td>
                    <td>
                      <div>
                        <div>
                          {formData?.[0]?.approver?.first_name ?? "-"}{" "}
                          {formData?.[0]?.approver?.last_name ?? "-"}
                        </div>
                        {formData?.[0]?.approvedAt && (
                          <div style={{ fontSize: "0.8em", color: "gray" }}>
                            (
                            {formData?.[0]?.approvedAt
                              ? new Date(
                                  formData?.[0]?.approvedAt
                                ).toLocaleDateString("en-GB")
                              : "-"}
                            )
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                      <i
                        type="button"
                        onClick={() => handleModalLogShow(formId)}
                        className="mdi mdi-dots-vertical"
                      ></i>
                    </td>
                    {/* {approvalStatus !== "approved" ? (
                      <td>
                        <div className="d-flex mt-2 gap-2 justify-content-center ">
                          {kpi.isEdited && !kpi.isApproved && (
                            <button
                              className="btn btn-primary"
                              type="button"
                              onClick={() => {
                                navigate("/company/approve/social", {
                                  state: {
                                    year,
                                    groupConstant,
                                    type: "social",
                                    // kpiName,
                                  },
                                });
                              }}
                            >
                              Edit
                            </button>
                          )}
                          {(kpi.isApproved ||
                            user.role === USER_ROLE.Company) && (
                            <>
                              <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => handleModalShow("approve")}
                              >
                                Approve
                              </button>
                              <button
                                className="btn btn-primary"
                                type="button"
                                onClick={() => {
                                  navigate("/company/approve/social", {
                                    state: {
                                      year,
                                      groupConstant,
                                      type: "social",
                                      // kpiName,
                                    },
                                  });
                                }}
                              >
                                Edit
                              </button>
                              <button
                                className="btn btn-danger"
                                type="button"
                                onClick={() => handleModalShow("delete")}
                              >
                                Delete
                              </button>
                            </>
                          )}
                        </div>
                      </td>
                    ) : (
                      <td>-</td>
                    )} */}

                      {approvalStatus === "approved" ? (
                        <td>
                          <div className="d-flex mt-2 gap-2 justify-content-center">
                            {(user.role === USER_ROLE.Company || user.department === "Admin") ? (
                              <button
                                className="btn btn-danger"
                                type="button"
                                onClick={() => handleModalShow("delete")}
                              >
                                Delete
                              </button>
                            ) : (
                              <span>-</span>
                            )}
                          </div>
                        </td>
                      ) : (
                        <td>
                          <div className="d-flex mt-2 gap-2 justify-content-center">
                            {(user.role === USER_ROLE.Company || user.department === "Admin" || kpi.isApproved) ? (
                              <>
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  onClick={() => handleModalShow("approve")}
                                >
                                  Approve
                                </button>
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  onClick={() => {
                                    navigate("/company/approve/social", {
                                      state: {
                                        year,
                                        groupConstant,
                                        type: "social",
                                        month,
                                      },
                                    });
                                  }}
                                >
                                  Edit
                                </button>
                                <button
                                  className="btn btn-danger"
                                  type="button"
                                  onClick={() => handleModalShow("delete")}
                                >
                                  Delete
                                </button>
                              </>
                            ) : (
                              kpi?.isEdited && (
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  onClick={() => {
                                    navigate("/company/approve/social", {
                                      state: {
                                        year,
                                        groupConstant,
                                        type: "social",
                                        month,
                                      },
                                    });
                                  }}
                                >
                                  Edit
                                </button>
                              )
                            )}
                          </div>
                        </td>
                      )}
                  </tr>
                </tbody>
                {/* )} */}
              </table>
            </div>
          )}
          {/* approval status Message  */}
         
        </div>
        {showData ? (
          <ShowForm groupConstant={groupConstant} />
        ) : (
          <AddForm
            year={year}
            groupConstant={groupConstant}
            routeSubPath={routeSubPath}
            month={month}
          />
        )}
      </div>
      <Modal
        show={showModal}
        onHide={handleModalClose}
        size={modalType === "log" ? "xl" : ""}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "approve"
              ? "Approve Form"
              : modalType === "delete"
              ? "Delete Form"
              : "Log Details"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ overflow: "hidden" }}>
          {modalType === "approve" && (
            <p>Are you sure you want to approve this form?</p>
          )}
          {modalType === "delete" && (
            <p>
              Are you sure you want to delete this form? Once deleted, all data
              associated with this form will be permanently removed and cannot
              be recovered.
            </p>
          )}
          {modalType === "log" && (
            <div style={{ overflowX: "auto" }}>
              <table className="table table-responsive scroll">
                <thead>
                  <tr key={12} className="waterTabletr">
                    <th key={0}>Username</th>
                    <th key={1}>Date</th>
                    <th key={2}>Action</th>
                    <th key={3}>Ip</th>
                    <th key={4}>Request</th>
                  </tr>
                </thead>
                <LogTableBody logRaw={logRaw} formId={formId} approvalStatus={approvalStatus} />
              </table>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            Cancel
          </Button>
          {modalType === "approve" && (
            <Button variant="primary" onClick={handleConfirmAction}>
              Approve
            </Button>
          )}
          {modalType === "delete" && (
            <Button variant="primary" onClick={handleConfirmAction}>
              Delete
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default observer(SocialPage);
